import normalize from 'json-api-normalize'
import { ORDER_SUMMARY_ATTRS } from '@/clients/commercelayer/constants'

export interface LineItem {
  id: string
  type: string
  item_type: string
  image_url: string
  name: string
  sku_code: string
  quantity: number
  metadata: Record<string, string>
  formatted_unit_amount: string
  unit_amount_float: number
  compare_at_amount_float: number
  formatted_compare_at_amount: string
  formatted_total_amount: string
  total_amount_float: number
}

interface OrderAttributes {
  number: string
  status: 'draft' | 'pending' | 'placing' | 'placed' | 'editing' | 'cancelled' | 'approved'
  skus_count: number
  formatted_subtotal_amount: string
  formatted_discount_amount: string
  formatted_shipping_amount: string
  formatted_total_tax_amount: string
  formatted_gift_card_amount: string
  formatted_total_amount_with_taxes: string
  total_amount_with_taxes_float: number
  line_items: LineItem[]
  currency_code: string
  checkout_url?: string
}

export interface CLOrder {
  data: {
    id: string
    type: string
    attributes: OrderAttributes
  }
}

interface Order extends OrderAttributes {
  id: string
  type: string
}

export const getNormalizedCartSummary = (cartSummary: CLOrder): Order => {
  const normalizedOrder = normalize(cartSummary).get(ORDER_SUMMARY_ATTRS)

  if (!normalizedOrder) {
    console.error('Failed to normalize cart summary:', cartSummary)
    throw new Error('Failed to normalize cart summary')
  }

  return {
    ...normalizedOrder,
    line_items:
      normalizedOrder.line_items?.filter(
        ({ item_type }: { item_type: string }) => item_type === 'skus',
      ) ?? [],
  }
}
